import Component from '../../Component';
import Pagination from '../pagination';
import { WPRest } from '../wp-ajax';

interface PostGridState {
	busy: boolean;
}

class PostGrid extends Component<HTMLElement, PostGridState> {
	order: string = '';
	source: string = '';
	perPage: number = 0;
	postType: string = 'post';
	allPosts: string[] = [];
	pagination?: Pagination;

	static selector = '.post-grid';

	static children = {
		pagination: '.post-grid-pagination',
		gridContainer: '.tile-grid-container',
	};

	state = {
		busy: false,
	};

	afterInit() {
		this.parseElementData();

		if (this.children?.pagination) {
			this.initPagination();
		}
	}

	parseElementData() {
		this.allPosts = this.element
			.getAttribute('data-all-posts')
			?.split(',') as string[];
		this.perPage = Number(this.element.getAttribute('data-per-page') || 0);
		this.postType = this.element.getAttribute('data-post-type') || 'post';
		this.order = this.element.getAttribute('data-order') || '';
		this.source = this.element.getAttribute('data-source') || '';
	}

	initPagination() {
		this.pagination = new Pagination(
			this.children?.pagination as HTMLElement,
			{
				onChange: this.onPageSelect.bind(this),
				totalPages: Number(
					(this.children?.pagination as HTMLElement).getAttribute(
						'data-pages'
					) || 0
				),
			}
		);

		this.pagination.init();
	}

	onPageSelect(page: number) {
		const start = (page - 1) * this.perPage;
		const end = start + this.perPage;
		const newPosts = this.allPosts.slice(start, end);

		this.fetchPosts(newPosts);
	}

	async fetchPosts(posts: string[]) {
		const params = {
			include: posts,
			post_type: this.postType,
			source: this.source,
			count: -1,
			order: '',
		};

		this.setState({ busy: true });

		const { cards_rendered: cardsRendered } = await WPRest({
			path: '/post-cards',
			params,
		});

		this.replaceCards(cardsRendered);
		this.setState({ busy: false });
	}

	replaceCards(cardHtmls: string[] = []) {
		if (this.children?.gridContainer) {
			(this.children.gridContainer as HTMLElement).innerHTML =
				cardHtmls.join('\n');
		}
	}

	componentDidUpdate(changedState: Partial<PostGridState>): void {
		if ('busy' in changedState) {
			this.element.classList.toggle('post-grid--busy', changedState.busy);
		}
	}
}

PostGrid.init();
